import { render, staticRenderFns } from "./EndMessage.vue?vue&type=template&id=5ab95c33&scoped=true"
import script from "./EndMessage.vue?vue&type=script&lang=js"
export * from "./EndMessage.vue?vue&type=script&lang=js"
import style0 from "./EndMessage.vue?vue&type=style&index=0&id=5ab95c33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab95c33",
  null
  
)

export default component.exports